export default __webpack_public_path__ + "static/media/5.88b6c9ea.pdf";